export const FETCH_STORES = 'FETCH_STORES';
